import { useParams } from 'react-router-dom'

import { fetchSingleVideo } from '../utils/api'

import SingleVideo from '../components/SingleVideo/SingleVideo'

function Playlist () {
  const { playlistID } = useParams()

  return (
    <SingleVideo/>
  )
}

export default Playlist